import React, { useId } from 'react';
import './CartProductWithDelete.css';
import { Trash2 } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { unitPrice, formatMoney } from '../../utils/cartPricing';
import { closeCartModal } from '../../redux/Slices/CartModal';

const CartProductWithDelete = ({ data, onDelete, onQuantityChange }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const quantityId = useId();
  const {
    productId,
    sku,
    name,
    quantity,
    imageUrl,
    size,
    color,
    variation,
    stock,
    quantityDiscount,
    basePrice
  } = data;

  const handleQuantityChange = (event) => {
    const newQuantity = parseInt(event.target.value, 10);
    if (newQuantity > 0) {
      onQuantityChange({ 
        productId, 
        sku,
        size, 
        color, 
        variation, 
        quantity: newQuantity, 
        stock,
        quantityDiscount 
      });
    }
  };

  const handleIncrement = () => {
    onQuantityChange({ 
      productId, 
      sku,
      size, 
      color, 
      variation, 
      quantity: quantity + 1, 
      stock,
      quantityDiscount 
    });
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      onQuantityChange({ 
        productId, 
        sku,
        size, 
        color, 
        variation, 
        quantity: quantity - 1, 
        stock,
        quantityDiscount 
      });
    }
  };

  const handleDelete = () => {
    onDelete(data);
  };

  const handleNavigateToProduct = () => {
    navigate(`/product/${productId}`);
    dispatch(closeCartModal());
  };

  // Use discountedPrice if available, otherwise use price
  const displayPrice = unitPrice(data);


  return (
    <div className="cart-product">
      <img src={imageUrl} alt={name} className="cart-product-image" />
      <div className="cart-product-details">
        <h5 onClick={handleNavigateToProduct} className="cart-product-name" style={{ cursor: "pointer" }}>{name}</h5>
        {data.unavailable && <p role="status">Inte tillgänglig i valt antal</p>}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {basePrice && displayPrice < basePrice ? (
            <>
              <p className="cart-product-price" style={{ textDecoration: 'line-through', color: 'gray', fontSize: '14px' }}>
                {formatMoney(basePrice)}
              </p>
              <p className="cart-product-price" style={{ color: 'red', fontWeight: 'bold' }}>
                {formatMoney(displayPrice)}
              </p>
            </>
          ) : (
            <p className="cart-product-price">{formatMoney(displayPrice)}</p>
          )}
        </div>

        {/* <div className="cart-product-variations">
          {size && <p className="cart-product-variation"><strong>Size:</strong> {size}</p>}
          {color && <p className="cart-product-variation"><strong>Color:</strong> {color}</p>}
        </div> */}

        <div className="cart-product-quantity-delete-row">
          <div className="cart-product-quantity">
            <label htmlFor={quantityId} className="quantity-label">Antal:</label>
            <div className="quantity-input-container">
              <button type="button" aria-label={`Minska antal ${name}`} disabled={quantity <= 1} className="quantity-btn" onClick={handleDecrement}>-</button>
              <input
                id={quantityId}
                type="number"
                value={quantity}
                min="1"
                max={stock}
                step="1"
                className="quantity-input"
                onChange={handleQuantityChange}
              />
              <button type="button" aria-label={`Öka antal ${name}`} disabled={stock != null && quantity >= stock} className="quantity-btn" onClick={handleIncrement}>+</button>
            </div>
          </div>
          <button type="button" aria-label={`Ta bort ${name}`} className="btn btn-danger cart-product-delete" onClick={handleDelete}>
            <Trash2 />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartProductWithDelete;
